import 'Magaele/ic-ln/css.scss';
import 'Magaele/ic-lnpx/css.scss';
import 'Magaele/ps_lnls/css.scss';
import 'Magaele/th_lnop/css.scss';
import 'Magaele/clp_gpby/css.scss';
import 'Magaele/th_gpls/css.scss';
import 'Magaele/clp_gplt/css.scss';
import 'Magaele/tb_htrm/css.scss';
import 'Magaele/bt_gptr/css.scss';
import 'Magaele/nvb_gptb/css.scss';
import 'Magaele/pp_ln/css.scss';
import 'Magaele/tb_htpr/css.scss';
import 'Magaele/mdl_lnls/css.scss';
import 'Magaele/th_gplt/css.scss';
import 'Magaele/lb_htif/css.scss';
import 'Magaele/sf-lnse/css.scss';
import 'Magaele/st_lnls/css.scss';
import 'Magaele/fcl_lnls/css.scss';
import 'Magaele/int_lnls/css.scss';
import 'Magaele/cy-ln/css.scss';
import 'Magaele/btg_gpct/css.scss';
import 'Magaele/st_lnht/css.scss';


import "../css/css.scss"; 


// WEBPACK FOOTER //
// ./entry/booking_style.entry.js